import { GlobalEventWarningText } from "features/CenterContent/RoleContent/GlobalEvents/GlobalEventWarningText";
import { FC } from "react";
import { Checkbox, HStack, Stack, Text } from "shared/components/Spor";

type CheckboxProps = {
  editGlobalEvent: boolean;
  setEditGlobalEvent: (value: boolean) => void;
};
export const EditGlobalEventCheckbox: FC<CheckboxProps> = ({
  editGlobalEvent,
  setEditGlobalEvent,
}) => (
  <HStack alignItems="start">
    <Checkbox
      checked={editGlobalEvent}
      onCheckedChange={() => setEditGlobalEvent(!editGlobalEvent)}
    />
    <Stack>
      <Text variant="sm">Oppdater også global driftsmelding</Text>
      <GlobalEventWarningText />
    </Stack>
  </HStack>
);
